<div class="modal-header">
  <h4 class="modal-title">{{ 'business-email.modal-title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  @if (state === 'loading') {
    <div class="frame loading">
      <mat-icon svgIcon="loader"></mat-icon>
      <div>{{ 'business-email.loading' | translate }} </div>
    </div>
  } @else {
    <div class="frame">
      <div>{{ 'common.error-encountered' | translate}}</div>
      <ex-button type="secondary" variant="raised" size="small" (click)="run()">
        {{ 'common.retry' | translate}}
      </ex-button>
    </div>
  }
</div>
